export default {"src":"/_next/static/media/li.393a0ba4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};